"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var appointment_1 = __importDefault(require("./appointment"));
var Appointments = /** @class */ (function () {
    function Appointments(payload) {
        var _this = this;
        this.workexecutionId = payload.workexecutionId;
        this.slots = new Array();
        payload.slots.forEach(function (element) {
            return _this.slots.push(new appointment_1.default(element));
        });
    }
    return Appointments;
}());
exports.default = Appointments;
